import { FormikErrors, FormikTouched } from 'formik';

export function isFieldError<T>(
  field: keyof T,
  touched: FormikTouched<T>,
  errors: FormikErrors<T>,
): boolean {
  return Boolean(
    touched?.[field] !== undefined && errors?.[field] !== undefined,
  );
}
